import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '运营工作台', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '运营工作台', icon: 'dashboard'}
    }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/spu',
    name: 'pms',
    meta: {title: '产品服务', icon: 'product'},
    children: [
      {
        path: 'spu',
        name: 'spu',
        component: () => import('@/views/pms/spu/index'),
        meta: {title: '产品治理', icon: 'product-list'}
      },
      {
        path: 'skuSlot',
        name: 'skuSlot',
        component: () => import('@/views/pms/skuSlot/index'),
        meta: {title: '服务时段', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销配置', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '限时活动', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '活动时段'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '选择活动时段'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '活动服务配置'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '新建优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '编辑优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券使用记录'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '合作方推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新服务推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '热门服务推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '主题内容推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告位', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '新建广告位'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告位'},
        hidden:true
      },
      {
        path: 'tripShare',
        name: 'tripShare',
        component: () => import('@/views/sms/tripShare/index'),
        meta: {title: '行程分享', icon: 'sms-ad'}
      }
    ]
  },
  {
    path: '/ops',
    component: Layout,
    redirect: '/ops/orderCenter',
    name: 'ops',
    meta: {title: '运营中台', icon: 'dashboard'},
    children: [
      {
        path: 'orderCenter',
        name: 'opsOrderCenter',
        component: () => import('@/views/ops/order/index'),
        meta: {title: '订单总览', icon: 'order'}
      },
      {
        path: 'discoverCenter',
        name: 'opsDiscoverCenter',
        component: () => import('@/views/ops/discover/index'),
        meta: {title: '发现审核', icon: 'sms-subject'}
      },
      {
        path: 'discoverGovernance',
        name: 'opsDiscoverGovernance',
        component: () => import('@/views/ops/discoverGovernance/index'),
        meta: {title: '组局与社交治理', icon: 'sms-subject'}
      },
      {
        path: 'withdrawCenter',
        name: 'opsWithdrawCenter',
        component: () => import('@/views/ops/withdraw/index'),
        meta: {title: '商家提现审核', icon: 'money'}
      },
      {
        path: 'memberWithdrawCenter',
        name: 'opsMemberWithdrawCenter',
        component: () => import('@/views/ops/memberWithdraw/index'),
        meta: {title: '用户提现审核', icon: 'money'}
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/dictType',
    name: 'sys',
    meta: {title: '系统配置', icon: 'tree'},
    children: [
      {
        path: 'dictType',
        name: 'dictType',
        component: () => import('@/views/sys/dictType/index'),
        meta: {title: '字典类型', icon: 'table'}
      },
      {
        path: 'dictItem',
        name: 'dictItem',
        component: () => import('@/views/sys/dictItem/index'),
        meta: {title: '字典条目', icon: 'table'}
      }
    ]
  },
  {
    path: '/cms',
    component: Layout,
    redirect: '/cms/regionCountry',
    name: 'cms',
    meta: {title: '地区配置', icon: 'product-cate'},
    children: [
      {
        path: 'regionCountry',
        name: 'regionCountry',
        component: () => import('@/views/cms/regionCountry/index'),
        meta: {title: '服务国家', icon: 'product-attr'}
      },
      {
        path: 'regionCity',
        name: 'regionCity',
        component: () => import('@/views/cms/regionCity/index'),
        meta: {title: '服务城市', icon: 'product-attr'}
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '账号权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '后台账号', icon: 'ums-admin'}
      },
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/ums/member/index'),
        meta: {title: '用户治理', icon: 'ums-admin'}
      },
      {
        path: 'merchant',
        name: 'merchant',
        component: () => import('@/views/ums/merchant/index'),
        meta: {title: '商家治理', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色权限', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '配置菜单权限'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '配置接口权限'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单配置', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '新建菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '编辑菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '接口资源', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分组'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js